"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Factory = require('rosie').Factory;

var Chance = require('chance');

var moment = require('moment-business-days');

var PaperProduct = require('../products/interfaces/PaperProduct');

var chance = new Chance(12345);

var ShineProducts = require('../products');

var ShineOrders = require('../orders');

var productTypes = require('./productTypes.json');

function generatePersonalization() {
  if (this.product_type.match(/Wedding Invitation/)) {
    this.personalization.push({
      name: 'Invitation Wording',
      value: chance.paragraph()
    });
  }

  if (this.product_type.match(/Program/)) {
    this.personalization.push({
      name: 'Names, Date, Location',
      value: chance.paragraph()
    });
    this.personalization.push({
      name: 'Wedding Party',
      value: chance.paragraph()
    });
    this.personalization.push({
      name: 'Ceremony',
      value: chance.paragraph()
    });
    this.personalization.push({
      name: 'Additional Wording',
      value: chance.paragraph()
    });
  }

  if (this.product_type.match(/Sign/)) {
    this.personalization.push({
      name: 'Wording',
      value: chance.paragraph()
    });
  }
}

function createRandomProduct(product_category, reprints) {
  var products = reprints ? productTypes[product_category].reprint : productTypes[product_category]["default"];
  var productType = products[chance.integer({
    min: 0,
    max: products.length - 1
  })];
  var product = ShineProducts.instance()[productType].make();
  product.defaults();
  var ink_colors = ShineProducts.instance().standardColors().filter(function (_ref) {
    var active = _ref.active;
    return active;
  }).map(function (_ref2) {
    var text = _ref2.text;
    return text;
  });
  var design_names = ShineProducts.instance().designStyles().filter(function (_ref3) {
    var active = _ref3.active;
    return active;
  }).map(function (_ref4) {
    var text = _ref4.text;
    return text;
  });

  if (Object.prototype.isPrototypeOf.call(PaperProduct.prototype, product)) {
    product.design_name = design_names[chance.integer({
      min: 0,
      max: design_names.length - 1
    })];
    product.ink_colors = [ink_colors[chance.integer({
      min: 0,
      max: ink_colors.length - 1
    })]];

    if (product.type.match(/letterpress/)) {
      product.letterpress_ink_colors = [ink_colors[chance.integer({
        min: 0,
        max: ink_colors.length - 1
      })]];
    }
  }

  generatePersonalization.call(product);
  return product;
}

var statuses = ['hold', 'new', 'proofing', 'printing', 'approved', 'shipped', 'canceled'];
var designer_ids = ['-LZ_I1xDl3NMyhAOSeK3', '-LZ_I1xDl3NMyhAOSeK4', '-LZ_I1xDl3NMyhAOSeK5', '-LZ_I1xDl3NMyhAOSeK7', '-LZ_I1xDl3NMyhAOSeK9', '-LZ_I1xDl3NMyhAOSeKA', '-LZ_I1xEnUTv41PAbRG2', '-LZ_I1xEnUTv41PAbRG3', '-LZ_I1xEnUTv41PAbRG5', '-LZ_I1xEnUTv41PAbRG6', '-LZ_I1xEnUTv41PAbRGA', '-LZ_I1xEnUTv41PAbRGB'];
var product_categories = ['invitation_suites', 'embellishments', 'prewedding_stationery', 'wedding_programs', 'wedding_day_stationery', 'samples'];
var factory = Factory.define('order').attr('random_seed', 1).option('num_products', 0).option('reprints', false).option('exclude_product_categories', []).sequence('id').attr('country', ['country'], function (country) {
  return country;
}).attrs({
  oid: function oid() {
    return chance.string({
      length: 5,
      pool: '1234567890'
    });
  },
  designer_id: function designer_id() {
    return designer_ids[chance.integer({
      min: 0,
      max: designer_ids.length - 1
    })];
  },
  event_date: function event_date() {
    return moment().add(chance.integer({
      min: 80,
      max: 365
    }), 'days').toISOString();
  },
  status: function status() {
    return statuses[chance.integer({
      min: 0,
      max: statuses.length - 1
    })];
  },
  archived: false,
  designation: 'orders',
  email: function email() {
    return chance.email();
  },
  telephone: function telephone() {
    return chance.phone();
  },
  lastname: function lastname() {
    return chance.last();
  },
  firstname: function firstname() {
    return chance.first();
  },
  address1: function address1() {
    return chance.address();
  },
  city: function city() {
    return chance.city();
  },
  state: function state() {
    return chance.state();
  },
  zip: function zip() {
    return chance.zip();
  },
  country: 'US',
  tax_rate: 0.000,
  price_adjustment: 0,
  client_payment: 0
}) // .attr('notes', () => {
//     const notes = [];
//     const rand = chance.d8();
//     switch (rand) {
//         case 1: {
//             notes.push({
//                 timestamp: moment().businessSubtract(chance.integer({ min: 0, max: 24 }), 'days'),
//                 user_id: designer_ids[chance.integer({ min: 0, max: designer_ids.length - 1 })],
//                 designation: 'order',
//                 text: chance.sentence(),
//             });
//             break;
//         }
//         case 2: {
//             notes.push({
//                 timestamp: moment().businessSubtract(chance.integer({ min: 0, max: 24 }), 'days'),
//                 user_id: designer_ids[chance.integer({ min: 0, max: designer_ids.length - 1 })],
//                 designation: 'printer',
//                 text: chance.sentence(),
//             });
//             break;
//         }
//         case 3: {
//             notes.push({
//                 timestamp: moment().businessSubtract(chance.integer({ min: 0, max: 24 }), 'days'),
//                 user_id: designer_ids[chance.integer({ min: 0, max: designer_ids.length - 1 })],
//                 designation: 'shipper',
//                 text: chance.sentence(),
//             });
//             break;
//         }
//         case 4: {
//             notes.push({
//                 timestamp: moment().businessSubtract(chance.integer({ min: 0, max: 24 }), 'days'),
//                 user_id: designer_ids[chance.integer({ min: 0, max: designer_ids.length - 1 })],
//                 designation: 'payment',
//                 text: chance.sentence(),
//             });
//             break;
//         }
//         default:
//     }
//     return notes;
// })
.attr('order_date', ['status'], function (status) {
  if (status === 'new') {
    return moment().subtract(chance.integer({
      min: 0,
      max: 4
    }), 'days').toISOString();
  }

  return moment().subtract(chance.integer({
    min: 10,
    max: 50
  }), 'days').toISOString();
}).attr('products', ['num_products', 'exclude_product_categories', 'reprints'], function (num_products, exclude_product_categories, reprints) {
  var products = [];
  var categories = product_categories.filter(function (cat) {
    return !exclude_product_categories.includes(cat);
  });
  var n = num_products > 0 ? num_products : chance.integer({
    min: 1,
    max: 4
  });

  for (var i = 0; i < n; i++) {
    var product_category = categories[chance.integer({
      min: 0,
      max: categories.length - 1
    })];
    products.push(createRandomProduct(product_category, reprints));
  }

  return products;
}).after(function (obj, opts) {
  var order = ShineOrders.instance().make(_objectSpread(_objectSpread({}, obj), opts));
  order.defaultShippingService();
  order.client_payment = order.total_price;
  return order;
});
module.exports = factory;